import React from 'react';
import { DataUploadView } from 'src/features/DataUpload/components/templates/DataUploadView';

type DataUploadStepWrapperProps = {
  onUploadedDataChange?: (hasUploadedData: boolean) => void;
};

export const DataUploadStepWrapper: React.FC<DataUploadStepWrapperProps> = ({
  onUploadedDataChange,
}) => {
  return <DataUploadView onUploadedDataChange={onUploadedDataChange} />;
};
